import React, { Fragment, useEffect, useState } from 'react';
import { userImg } from '../../lib/constants';
import { useFetch } from '../../lib/useFetch';
import RecordsTable from './recordsTable';
import PaginationBar from '../../components/pagination';
import { formatDate } from '../../lib/helpers';
import { Nav } from "tabler-react";

const tableHeaders = ["Shopper", "Pick Up", "Destination", "Status", "Shipment Date", "Deliver Before"];
const mapResponseData = (data) => {
  const getTrimmedObj = (obj) => {
    if (!obj.fromCity)
      alert(obj['_id'])


    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['owner'] = {
      ID: obj.owner.userId,
      img: (obj.owner && obj.owner.photo) || userImg,
      user: obj.owner && obj.owner.username
    }
    trimmedObj['pickup'] = obj.fromCity.name;
    trimmedObj['Destination'] = obj.toCity.name;
    trimmedObj['state'] = obj.state;
    trimmedObj['createdAt'] = formatDate(new Date(obj.createdAt))
    trimmedObj['arrivalDate'] = formatDate(new Date(obj.shipmentArrivalDate))
    trimmedObj['tripId'] = obj.tripId;
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const statuses = ["In Negotiation", "Offer Accepted", "Payment Successful",
  "waiting for picking", "Picked"]

const milestones = ["", "Placed", "In Progress", "Delivered"]

const Shipments = ({ openMainModal, closeMainModal, location }) => {
  const getType = () => {
    const paths = {
      '/shipments/ShipmentOnly': `shipmentType=ShipmentOnly`,
      '/shipments/PrimeShipment': `shipmentType=PrimeShipment`,
      '/shipments/PurchaseShipment': `shipmentType=PurchaseAndShip`,
    }
    return paths[location.pathname] || ''
  }
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)
  const [status, setStatus] = useState('')
  const [milestone, setMilestone] = useState('')
  const [relatedStatuses, setRelatedStatuses] = useState([])

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`shipments?page=${page}&${getType()}&${status && `state=${status}`}&${milestone && `milestone=${milestone}`}&sort=createdAt:-1${searchParam}`, reload);

  useEffect(() => {
    setPage(1)
  }, [status])

  useEffect(() => {
    if (milestone === milestones[1])
      setRelatedStatuses(["", statuses[0], statuses[1], statuses[2]])
    else if (milestone === milestones[2])
      setRelatedStatuses(["", statuses[3], statuses[4]])
    else if (milestone === milestones[3])
      setRelatedStatuses([""])
    else
      setRelatedStatuses(["", ...statuses])
    setStatus("")
  }, [milestone])

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={tableHeaders}
        records={mapResponseData(data)}
        closeMainModal={closeMainModal}
        openMainModal={openMainModal}
        status={status}
        reload={() => toggleReload(r => !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      >
        <>
          <Nav>
            {relatedStatuses.map((item, i) =>
              <Nav.Item key={i}
                active={status === item} icon=""
                onClick={() => setStatus(item)}
              >
                {item || "All"}
              </Nav.Item>
            )}
          </Nav>
          <Nav>
            {milestones.map((item, i) =>
              <Nav.Item key={i}
                active={milestone === item} icon=""
                onClick={() => setMilestone(item)}
              >
                {item || "All"}
              </Nav.Item>
            )}
          </Nav>
        </>
      </RecordsTable>

      {
        data && data.length > 0 &&
        <PaginationBar
          page={page}
          totalCount={totalCount}
          setPage={setPage}
        />
      }
    </Fragment >
  );
}
export default Shipments;